import { AttendanceStatus } from '../../pages/RegisterAppointment/enums';

interface IAppointmentOverviewRowProps {
  field: string;
  value: string | string[];
}

function AppointmentOverviewRow({
  field,
  value,
}: IAppointmentOverviewRowProps) {
  return (
    <>
      <div className="col-span-1 text-lg text-right text-subtitle">
        {field}:
      </div>
      <div className="col-span-1 text-lg font-semibold">
        {typeof value === 'string'
          ? value
          : value.map((x) => <li key={x}>{x}</li>)}
      </div>
    </>
  );
}

interface IAppointmentOverviewProps {
  fcpName: string;
  doubleAppointment: boolean | null;
  dateOfConsultation: Date | null;
  organisation: string;
  pcnName: string;
  icsCcgName: string;
  referralSource: string;
  modeOfContact: string;
  consultationType: string;
  consultationOutcomes: string[];
  patientAgeRange: string;
  attendanceStatus: AttendanceStatus;
  followUpReason: string;
  followUpMethod: string;
  showFollowUpInfo: boolean;
  interpreterRequired: boolean;
  doubleAppointmentReason?: string;
}

export default function IAppointmentOverview({
  fcpName,
  doubleAppointment,
  dateOfConsultation,
  organisation,
  pcnName,
  icsCcgName,
  referralSource,
  modeOfContact,
  consultationType,
  consultationOutcomes,
  patientAgeRange,
  attendanceStatus,
  followUpMethod,
  followUpReason,
  showFollowUpInfo,
  interpreterRequired,
  doubleAppointmentReason,
}: IAppointmentOverviewProps) {
  window.addEventListener('popstate', (e) => {
    e.preventDefault();
  });

  const interpreterWasRequired = interpreterRequired ? 'Yes' : 'No';

  return (
    <div className="grid grid-cols-2 gap-2 my-8">
      <AppointmentOverviewRow field="FCP Name" value={fcpName} />
      <AppointmentOverviewRow
        field="Attendance status"
        value={attendanceStatus}
      />
      <AppointmentOverviewRow
        field="Appointment Type"
        value={doubleAppointment ? 'Double' : 'Single'}
      />
      {doubleAppointmentReason && (
        <AppointmentOverviewRow
          field="Double Appointment Reason"
          value={doubleAppointmentReason}
        />
      )}
      <AppointmentOverviewRow
        field="Date of consultation"
        value={dateOfConsultation?.toLocaleDateString('en-GB') ?? ''}
      />
      <AppointmentOverviewRow
        field="GP Practice referred from"
        value={organisation}
      />
      <AppointmentOverviewRow field="PCN Name" value={pcnName} />
      <AppointmentOverviewRow field="ICB Name" value={icsCcgName ?? ''} />
      <AppointmentOverviewRow field="Referral Source" value={referralSource} />
      <AppointmentOverviewRow
        field="Mode of Consultation"
        value={modeOfContact}
      />
      <AppointmentOverviewRow
        field="Patient Age Range"
        value={patientAgeRange}
      />
      <AppointmentOverviewRow
        field="Interpreter Required"
        value={interpreterWasRequired}
      />
      <AppointmentOverviewRow
        field="Consultation Type"
        value={consultationType}
      />
      {showFollowUpInfo && (
        <>
          <AppointmentOverviewRow
            field="Follow Up Method"
            value={followUpMethod}
          />
          <AppointmentOverviewRow
            field="Follow up Reason"
            value={followUpReason}
          />
        </>
      )}
      {attendanceStatus === AttendanceStatus.Attended && (
        <AppointmentOverviewRow
          field="Consultation Outcome(s)"
          value={consultationOutcomes}
        />
      )}
    </div>
  );
}
